<template>
  <div class="driver-scheduling" v-loading="loading">
    <div class="search-form-box">
      <el-row :gutter="30">
        <el-form inline>
          <el-col :span="6">
            <el-form-item label="服务商:">
              <el-select style="width: 100%" clearable v-model="searchForm.companyId" placeholder="请选择">
                <el-option
                  v-for="item in supplierData"
                  :key="item.companyId"
                  :label="item.companyName"
                  :value="item.companyId"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="月份:">
              <el-date-picker
                style="width: 100%"
                :clearable="false"
                @change="getDetail"
                v-model="searchForm.month"
                type="month"
                value-format="yyyy-MM"
                format="yyyy-MM"
                placeholder="请选择"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="">
              <el-button type="primary" round icon="el-icon-search" @click="getDetail()"></el-button>
              <el-button type="default" round icon="el-icon-refresh" @click="handleReset()"></el-button>
            </el-form-item>
          </el-col>
        </el-form>
      </el-row>
    </div>
    <div class="custom-table-box si-template">
      <el-calendar v-model="currentDate">
        <template slot="dateCell" slot-scope="{ date }">
          <div class="calendar-day" :class="{ disabled: !isCurrentMonth(date),
                    'before-today': isBeforeToday(date) }" @click="handleDayClick(date)">
            <div class="day-num">{{ date.getDate() }}</div>
            <div v-if="isCurrentMonth(date)">
              <div class="value-box">
                <div class="value-txt">
                  <div class="dot dot1"></div>
                  <div>出勤：</div>
                </div>
                <div class="value-num">{{getStatusText(date, "attendanceNum")}}</div>
              </div>
              <div class="value-box">
                <div class="value-txt">
                  <div class="dot dot2"></div>
                  <div>不出勤：</div>
                </div>
                <div class="value-num">{{getStatusText(date, "notAttendanceNum")}}</div>
              </div>
              <div class="value-box">
                <div class="value-txt">
                  <div class="dot dot3"></div>
                  <div>待排班：</div>
                </div>
                <div class="value-num">{{getStatusText(date, "unSchedulingNum")}}</div>
              </div>
            </div>
          </div>
        </template>
      </el-calendar>
    </div>
    <!--    添加或编辑-->

    <driverCalendarInfo ref="driverCalendarInfo" @success="getDetail"></driverCalendarInfo>
  </div>
</template>
<script>

import CustomTable from "@/components/CustomTable.vue";
import {defineComponent} from "vue";
import driverCalendarInfo from "@/views/FleetLeaderWorkbench/DriverWorkforceManagement/driverCalendarInfo.vue";
import CustomTabBox from "@/components/customComponents/CustomTabBox.vue";
import OperateBox from "@/components/OperateBox.vue";
import dayjs from "dayjs"
import {
  getCalendarList,
} from "@/views/FleetLeaderWorkbench/DriverWorkforceManagement/api";
import {getSelectSupplier} from "@/views/SystemManagement/ServiceManagement/api";

export default defineComponent({
  components: {
    CustomTabBox,
    OperateBox,
    CustomTable,
    driverCalendarInfo,
  },
  data() {
    return {
      searchForm: {
        companyId: "",
        month: dayjs().format('YYYY-MM')
      },
      currentDate: "",
      supplierData: [],
      scheduleData: [],
      loading: false
    }
  },
  created() {
    this.currentDate = new Date()
    this.getOver()
    this.getDetail()
  },
  methods: {
    getDetail() {
      this.loading = true
      getCalendarList({
        companyId: this.searchForm.companyId,
        month: this.searchForm.month,
      }).then((res) => {
        this.currentDate = this.searchForm.month;
        if (res.code === 200) {
          this.scheduleData = res.data;
        }
      }).finally(()=>{
        this.loading = false
      })
    },
    handleReset() {
      this.searchForm.companyId = "";
      this.searchForm.month = dayjs().format('YYYY-MM');
      this.getDetail()
    },
    getOver() {
      getSelectSupplier({belongCompanyId: '',keyword: ''}).then((res) => {
        if (res.code === 200) {
          this.supplierData = res.data;
        }
      });
    },
    // 判断是否当前月份
    isCurrentMonth(date) {
      const current = new Date(this.currentDate);
      return (
          date.getFullYear() === current.getFullYear() &&
          date.getMonth() === current.getMonth()
      );
    },
    // 点击处理：非当月直接 return
    handleDayClick(date) {
      if (!this.isCurrentMonth(date)) return;
      const dateStr = date.toISOString().split("T")[0];
      // // console.log("点击当月日期：", dateStr);
      // if (this.isBeforeToday(dateStr)) {
      //   return;
      // } else {
        this.$refs.driverCalendarInfo.init(this.getScheduleItem(dateStr), this.supplierData, this.searchForm.companyId);
      // }
      // 你自己的业务逻辑
    },
    getScheduleItem(date) {
      // 1. 把传入的日期统一转成 YYYY-MM-DD 格式
      const targetDate = dayjs(date).format('YYYY-MM-DD')

      // 2. 从你的排班列表里查找匹配项
      const list = this.scheduleData || []

      // 3. 返回找到的那一项（没有就返回 null）
      return list.find(item => item.date === targetDate)
    },
    //
    isBeforeToday(targetDate) {
      const target = dayjs(targetDate).startOf('day')
      const today = dayjs().startOf('day')
      return target < today
    },
    // 获取排班
    getSchedule(date) {
      const dateStr = date.toISOString().split("T")[0];
      return this.scheduleData.find(
          (item) => item.date === dateStr
      );
    },
    getStatusText(date, key) {
      const s = this.getSchedule(date);
      if (!s) return "";
      return s[key];
    },
  },
})
</script>
<style scoped lang="scss">
.driver-scheduling{
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .search-table-box {
    display: flex;
    margin: 0 -0.1rem;
    .list-box {
      width: 25%;
      height: 0.9rem;
      border-radius: 0.08rem;
      background-color: #ffffff;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      margin: 0 0.1rem;
      .list-box-num {
        font-size: 0.24rem;
        color: #000000;
        padding-bottom: 0.1rem;
        font-weight: bold;
      }
      .list-box-label {
        font-size: 0.14rem;
        color: #434343;
      }
    }
  }
  .custom-table-box {
    padding-top: 0;
  }
  .schedule-container {
    padding: 20px;
  }
  .stats-wrapper {
    margin-bottom: 15px;
  }
  .stats-wrapper .el-tag {
    margin-right: 10px;
  }
  .calendar-day {
    width: 100%;
    height: 100%;
    text-align: center;
    padding: 2px 0;
    cursor: pointer;
    &.before-today {
      background: rgba(0,0,0,0.1); // 置灰背景// 文字变浅灰
      //pointer-events: none; // 可选：禁止点击过去日期
      .status {
        color: #ffffff;
      }
    }
  }
  /* 非当月：置灰 + 禁止点击 */
  .calendar-day.disabled {
    opacity: 0;
    pointer-events: none;
    background: #f5f5f5;
  }
  .day-num {
    font-weight: bold;
    margin-bottom: 4px;
  }
  .status {
    display: inline-block;
    padding: 1px 4px;
    font-size: 11px;
    color: #fff;
    border-radius: 3px;
    margin-bottom: 3px;
  }
  .dispatch {
    font-size: 10px;
    color: #666;
    padding-top: 6px;
  }
  .wait { background: #e6a23c; }
  .work { background: #67c23a; }
  .rest { background: #f56c6c; }
  .default { background: #eee; }
  ::v-deep .el-calendar {
    .el-calendar-table{
      width: 100%;
      height: 100%;
      &:not(.is-range){
        td.next{
          pointer-events: none;
        }
        td.prev{
          pointer-events: none;
        }
      }
    }
  }
  .dot-detail{
    display: flex;
    align-items: center;
    position: absolute;
    top: 15px;
    left: 50%;
    transform: translateX(-50%);
    .detail-box{
      margin-right: 10px;
      .label-text{
        color: #fff;
        border-radius: 2px;
        padding: 2px 4px;
      }
      .value-text{
        font-size: 16px;
        padding-left: 10px;
      }
    }
    .detail-box:nth-of-type(1){
      .label-text{
        background: #67c23a;
      }
    }
    .detail-box:nth-of-type(2){
      .label-text{
        background: #f56c6c;
      }
    }
    .detail-box:nth-of-type(3){
      .label-text{
        background: #e6a23c;
      }
    }
  }
  .si-template{
    ::v-deep .el-calendar__header {
      display: none;
    }
    ::v-deep .el-calendar-day {
      height: auto;
      min-height: 1rem;
    }
  }
  .value-box{
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding-left: 30%;
    .value-txt{
      display: flex;
      align-items: center;
      line-height: 1.6;
      font-size: 0.14rem;
      width: 0.8rem;
      .dot{
        width: 0.14rem;
        height: 0.14rem;
        border-radius: 50%;
        background: #67c23a;
        margin-right: 0.08rem;
      }
      .dot1{
        background: #67c23a;
      }
      .dot2{
        background: red;
      }
      .dot3{
        background: #ebb563;
      }
    }
    .value-num{
      font-size: 0.18rem;
    }
  }
}
</style>
